import React, { useContext } from 'react'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import { Context } from '../context'
import AddCouponDialog from './add-coupon-dialog'

const AddCoupon = styled.div`
  cursor: pointer;
  color: #0376DA;
  margin: 24px;
  text-align: center;
`

export default () => {
  const { coupon, showDialog } = useContext(Context)

  const showAddCoupon = () => {
    showDialog(<AddCouponDialog />)
  }

  if (coupon) {
    return (
      <AddCoupon>
        {translate('coupon_discount')} {coupon.discount * 100}%
      </AddCoupon>
    )
  }

  return (
    <AddCoupon onClick={showAddCoupon}>
      {translate('add_coupon_code')}
    </AddCoupon>
  )
}
